import { render, staticRenderFns } from "./PowerBandsChart.vue?vue&type=template&id=32993f9a&"
import script from "./PowerBandsChart.vue?vue&type=script&lang=js&"
export * from "./PowerBandsChart.vue?vue&type=script&lang=js&"
import style0 from "./PowerBandsChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports